import isNoData from "../is-no-data";
import pushAlpha from "../push-alpha";
// assuming valid RGB input
export default function quickly_convert(old_no_data_value, new_no_data_pixel, px) {
  return isNoData(old_no_data_value, px) ? new_no_data_pixel : pushAlpha(px);
}